module.exports = __webpack_public_path__ + "img/metta.9ade18d7.png";